import { render, staticRenderFns } from "./detail-back.vue?vue&type=template&id=58c9caae&"
import script from "./detail-back.vue?vue&type=script&lang=js&"
export * from "./detail-back.vue?vue&type=script&lang=js&"
import style0 from "./detail-back.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports